/* eslint-disable  @typescript-eslint/no-explicit-any */
import { getWithAuth } from '@/api/httpRequests'
import Config from '@/shared/config/config'
import { hexToRgb } from '@/shared/lib'
import {
    bootstrapsKeyword,
    getFromLocalStorage,
} from '@/shared/localStorage/localStorageRepository'

export const getApiConfigStreamIQ = async () => {
    const bootstrapsObjects = getFromLocalStorage(bootstrapsKeyword)
    if (!bootstrapsObjects) return

    const bootstraps = JSON.parse(bootstrapsObjects)

    const customVariable = bootstraps?.services?.['crm-service'].customVariable
    const termsAndConditionsDocument =
        bootstraps?.services?.['crm-service'].termsAndConditionsDocument

    const customVariableRes = await getWithAuth(customVariable, false)

    if (!customVariableRes) return

    const { response } = customVariableRes

    // const termsAndConditionsDocumentRes = await getWithAuth(
    //     termsAndConditionsDocument,
    //     false
    // )
    //
    // if (!termsAndConditionsDocumentRes) return
    //
    // const { response: termsAndConditions } = termsAndConditionsDocumentRes

    const mainColor = response.resources.filter(
        (item: any) => item.key === 'mainColor'
    )

    const secondaryColor = response.resources.filter(
        (item: any) => item.key === 'secondaryColor'
    )

    // const textColor = response.resources.filter(
    //     (item: any) => item.key === 'textColor'
    // )
    const logo = response.resources.filter((item: any) => item.key === 'logo')
    // const { url, version } = termsAndConditions.resources[0]

    const config = {
        skin: {
            appLoginScreenLogoUrl: logo[0].value,
            appMenuLogoUrl: logo[0].value,
            mainColor: hexToRgb(mainColor[0].value),
            secondaryColor: hexToRgb(secondaryColor[0].value),
            // textColor: hexToRgb(textColor[0].value),
            // textColor: '000',
        },
        termsAndConditions: {
            isTermsAccepted: false,
            url: '',
            version: 0,
        },
        channelsVersion: 0,
        configVersion: 0,
        epgVersion: 0,
        tvUpdateIntervals: {
            channelUpdateIntervalMaxRetries: 0,
            channelUpdateIntervalOnError: 0,
            configUpdateIntervalMaxDeviation: 0,
            configUpdateIntervalOnError: 0,
            configUpdateIntervalOnSuccess: 0,
            configUpdateMaxRetries: 0,
            epgPFUpdateIntervalOnError: 0,
            epgPFUpdateMaxRetries: 0,
            epgScheduleUpdateIntervalOnError: 0,
            epgScheduleUpdateMaxRetries: 0,
        },
        configSaveTime: 0,
        epgPresentFollowingCdnUriFile: '',
        epgScheduleCdnUriPrefix: '',
        shouldAuthenticateEpgFiles: false,
        appLogoUrl: '',
        rentalUri: '',
        faqUrl: '',
        privacyPolicyUrl: '',
    }

    if (logo) return new Config(config)

    return null
}
